import { createSelector } from 'selectors'

import { constant } from './constant'

export const getPptxExportSelector: (scope?: HTMLElement) => NodeListOf<HTMLElement> | null = (scope?: HTMLElement) =>
	createSelector({ scope, selector: constant.selector.pptxLinkExport }, true)
